import React from "react";
import {
  DataGrid,
  Column,
  FormItem,
  Selection,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import notify from "devextreme/ui/notify";
import { criarDamDs, criarAgentesRecebedoresDs } from "../DataSources";

import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button, ScrollView } from "devextreme-react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import PaginaToolbar from "../components/PaginaToolbar";
import apiAxios from "../api-axios";
import UserInfo from "../UserInfo";
import showReport from "../showReport";
import react from "react";
import Memoria from "../Memoria";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { DataSource } from "devextreme/data/data_source/data_source";
import { abrirDetalhe, abrirDetalheMigrado, imprimirDamFunction } from "../lancamentosUtils";
import ShowError from "../AppServices";

const data = new Date();

let _cadastroCorrente = undefined;
let _cancelando = false;
export default class DamsBox extends React.Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this._gridAtualizarDams = React.createRef();
    this.damDs = criarDamDs();

    this.executarAtualizacaoDams = this.executarAtualizacaoDams.bind(this);
    this.formatoMoeda = { type: "currency", useGrouping: true, precision: 2 };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.atualizarDams = this.atualizarDams.bind(this);
    this.onSelection = this.onSelection.bind(this);
    this.state = {
      carregando: true,
      listaTodosStatusUI: [],
      listaFiltrosUI: [],
      novaData: new Date(),
      somenteVencidos: true,
      popupDamsNaoPagos: false,
      popupCancelarDamDIAT: false,
      popupMotivoCancelarDam: false,
      popupInfoParcelaDam: false,
      damsNaoPagos: [],
      damsSelectionados: [],
      damCancelamento: {},
      encargos: 0,
      filtro: {
        exercicio: null,
        dam: null,
        codContribuinte: null,
        codImovel: null,
        codCpbs: null,
        origem: null,
        nomeContribuinte: null,
        cpfCnpj: null,
        tipoData: 2,
        dataInicial: null,
        dataFinal: null,
        codAgenteRecebedor: null,
        tipoValor: 1,
        valorInicial: null,
        valorFinal: null,
        situacaoDam: "NÃO PAGO"
      },
    };
    this.tipoDataOpcoes = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "Data de Emissão", campo: "dataDeEmissao" },
        { id: 2, descricao: "Data de Vencimento", campo: "dataDeVencimento" },
        { id: 3, descricao: "Data de Pagamento", campo: "dataDePagamento" },
        { id: 5, descricao: "Data de Crédito", campo: "dataDeDeposito" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoValorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "Valor" },
        { id: 2, descricao: "Valor Pago" },
        { id: 3, descricao: "Valor Total" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.tipoSituacaoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      showClearButton: true,
      dataSource: [],
      valueExpr: "descricao",
      displayExpr: "descricao",
      placeholder: " "
    };

    this.filtrarOpcoes = {
      type: "success",
      text: "Filtrar",
    };
    this.limparFiltroOpcoes = {
      text: "Limpar",
    };
    this.agentesRecebedoresDs = criarAgentesRecebedoresDs();
    this.agentesRecebedoresOpcoes = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: criarAgentesRecebedoresDs(),
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: true,
    };
    this.encargoOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Manter Encargos" },
        { id: 1, descricao: "Eliminar Multa" },
        { id: 2, descricao: "Eliminar Juros" },
        { id: 3, descricao: "Eliminar Correção" },
        { id: 4, descricao: "Eliminar Juros e Multa" },
        { id: 5, descricao: "Eliminar Tudo" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
    this.somenteVencidosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: true, descricao: "Sim" },
        { id: false, descricao: "Não" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.abrirDetalheLancamento = this.abrirDetalheLancamento.bind(this);
  }

  componentDidMount() {
    let listaTodosStatusUI = [];
    let listaFiltrosUI = [];

    apiAxios
      .get(`/dam/status_dam/${UserInfo.getPrefeitura()}`)
      .then(resp => {
        console.log("resp status", resp)
        const dados = resp.data;
        listaTodosStatusUI = dados.listaFiltros;
        listaFiltrosUI = dados.filtros;
      })
      .catch(error => {
        notify("Erro ao carregar os dados");
        console.log(error);
      })
      .finally(() => {
        this.setState({ carregando: false, listaTodosStatusUI, listaFiltrosUI });
        this.filtrar();
      });

  }

  executarAtualizacaoDams() {
    const request = {
      prefeituraId: UserInfo.getPrefeitura(),
      damsIds: this.state.damsSelectionados.map((x) => x.id),
      eliminarEncargos: this.state.encargos,
      novaData: this.state.novaData,
      somenteVencidos: this.state.somenteVencidos,
    };
    console.log("request atualizar", request);
    console.log("req atualizar", request);
    return showReport("/dam/atualizar", request);
  }

  limparFiltro() {
    this.setState({
      filtro: {
        exercicio: null,
        dam: null,
        codContribuinte: null,
        codImovel: null,
        codCpbs: null,
        origem: null,
        nomeContribuinte: null,
        cpfCnpj: null,
        tipoData: 2,
        dataInicial: null,
        dataFinal: null,
        codAgenteRecebedor: null,
        valorInicial: null,
        valorFinal: null,
        taxasSeqs: null
      },
    });

    this.filtrar();
  }

  filtrar() {
    let filtro = [];
    let estado = this.state.filtro;

    if (estado.exercicio != null) {
      filtro.push(["exercicio", "=", estado.exercicio]);
    }

    if (estado.dam != null) {
      filtro.push(["sequencial", "=", estado.dam]);
    }

    if (estado.codContribuinte != null) {
      filtro.push([
        "contribuinte.sequencial",
        "=",
        estado.codContribuinte,
      ]);
    }

    if (estado.codImovel != null) {
      filtro.push(["imovel.sequencial", "=", estado.codImovel]);
    }

    if (estado.codCpbs != null) {
      filtro.push(["cpbs.inscricao", "=", estado.codCpbs]);
    }

    if (estado.origem != null && estado.origem.trim() != "") {
      filtro.push(["receita.origem", "contains", estado.origem]);
    }

    if (estado.taxasSeqs != null && estado.taxasSeqs.trim() != "") {
      let taxasSeqsSplitedText = estado.taxasSeqs.split(',');

      console.log("taxas seqs splited", taxasSeqsSplitedText);

      let taxasSeqsFilter = [];

      for (let i = 0; i < taxasSeqsSplitedText.length; i++) {
        var elementFilter = taxasSeqsSplitedText[i].trim();

        if (elementFilter == "")
          continue;

        if (taxasSeqsFilter.length > 0)
          taxasSeqsFilter.push("OR");

        taxasSeqsFilter.push(["taxa.sequencial", "=", elementFilter]);
      }

      if (taxasSeqsFilter.length > 0) {
        console.log("taxas filter", taxasSeqsFilter);
        filtro.push(taxasSeqsFilter);
      }

    }

    if (
      estado.nomeContribuinte != null &&
      estado.nomeContribuinte.trim() != ""
    ) {
      filtro.push([
        "contribuinte.nome",
        "contains",
        estado.nomeContribuinte,
      ]);
    }

    if (estado.cpfCnpj != null && estado.cpfCnpj.trim() != "") {
      let cpfCnpjFormatado = estado.cpfCnpj.replace(/\D/g, "");
      filtro.push([
        "contribuinte.cpfCnpj",
        "contains",
        cpfCnpjFormatado,
      ]);
    }

    let campoData = this.tipoDataOpcoes.dataSource.filter(
      (p) => p.id == estado.tipoData
    )[0].campo;

    if (estado.dataInicial != null) {
      const data = estado.dataInicial;
      console.log("data inicial", data);
      filtro.push([
        campoData,
        ">=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          0,
          0,
          0,
          0
        ),
      ]);
    }

    if (estado.dataFinal != null) {
      const data = estado.dataFinal;
      console.log(data);
      filtro.push([
        campoData,
        "<=",
        new Date(
          data.getFullYear(),
          data.getMonth(),
          data.getDate(),
          23,
          5,
          59,
          999
        ),
      ]);
    }

    if (estado.codAgenteRecebedor != null) {
      filtro.push(["agenteRecebedorId", "=", estado.codAgenteRecebedor]);
    }

    if (
      estado.valorInicial !== null &&
      estado.valorInicial !== undefined &&
      estado.valorInicial !== ""
    ) {
      switch (estado.tipoValor) {
        case 1:
          filtro.push(["valor", ">=", estado.valorInicial]);
          break;
        case 2:
          filtro.push(["valorPago", ">=", estado.valorInicial]);
          break;
        case 3:
          filtro.push(["valorTotal", ">=", estado.valorInicial]);
          break;
      }
    }

    if (
      estado.valorFinal !== null &&
      estado.valorFinal !== undefined &&
      estado.valorFinal !== ""
    ) {
      switch (estado.tipoValor) {
        case 1:
          filtro.push(["valor", "<=", estado.valorFinal]);
          break;
        case 2:
          filtro.push(["valorPago", "<=", estado.valorFinal]);
          break;
        case 3:
          filtro.push(["valorTotal", "<=", estado.valorFinal]);
          break;
      }
    }

    if (
      estado.situacaoDam !== null &&
      estado.situacaoDam !== undefined &&
      estado.situacaoDam !== ""
    ) {

      const statusFiltrados = this.state.listaTodosStatusUI.filter(x => x.codigoFiltro == estado.situacaoDam);
      const filtroSituacao = [];

      for (let i = 0; i < statusFiltrados.length; i++) {
        if (i > 0) {
          filtroSituacao.push("or");
        }
        filtroSituacao.push(["statusStr", "=", statusFiltrados[i].codigo]);
      }

      console.log("filtro situacao", filtroSituacao);
      filtro.push(filtroSituacao);




    }

    console.log(filtro);
    this._gridInstance.instance.filter(filtro.length > 0 ? filtro : null);
  }

  atualizarDams() {
    const allData = this._gridInstance.instance
      .getVisibleRows()
      .map((x) => x.data);
    this._gridAtualizarDams.instance.clearSelection();
    const damsPodeAtualizar = allData.filter(
      (x) => x.situacaoPagto == "EM ABERTO" || x.situacaoPagto == "EM ATRASO"
    );
    this.setState({
      damsNaoPagos: damsPodeAtualizar,
      popupDamsNaoPagos: true,
      damsSelectionados: [],
      novaData: new Date(),
      encargos: 0,
      somenteVencidos: true,
    });

    // criarDamDs()
    //   .load({
    //     filter: [
    //       [
    //         ["situacaoStr", "=", "EM ABERTO"],
    //         "or",
    //         ["situacaoStr", "=", "EM ATRASO"],
    //       ],
    //     ],
    //   })
    //   .then((response) => {
    //     this.setState({ damsNaoPagos: response, popupDamsNaoPagos: true });
    //   });
  }

  onSelection(e) {
    console.log(e);
    this.setState({
      damsSelectionados: e.selectedRowsData,
    });
  }

  popupsCancelarDam(e) {
    const registro = e.row.data;
    console.log("dados cancelar dam", e);

    var dadosRegistro = e.row.data;

    if (dadosRegistro.excluida || dadosRegistro.paga) {
      notify("Registro não pode ser cancelado", "error");
      return;
    }

    if (
      dadosRegistro.lancamento &&
      dadosRegistro.lancamento.situacaoStr != "N"
    ) {
      notify("Registro não pode ser cancelado", "error");
      return;
    }

    this.setState({ ...this.state, damCancelamento: registro });

    if (registro.tipo.codigo === "DIVIDA ATIVA") {
      return this.setState({
        ...this.state,
        popupCancelarDamDIAT: true,
        motivo: "",
      });
    } else if (registro.numDaParcela > 1) {
      return this.setState({
        ...this.state,
        popupInfoParcelaDam: true,
        motivo: "",
      });
    } else {
      return this.setState({
        ...this.state,
        popupMotivoCancelarDam: true,
        motivo: "",
      });
    }
  }

  abrirDetalheLancamento(e) {
    console.log("e detalhe lancamento", e);

    const data = e.row.data;

    if (data.lancamento != undefined) {
      abrirDetalhe(this.props.history, e.row.data.lancamento);
      return;
    }

    notify("DAM de migração não pode acessar detalhe de lançamento.");
    return;

    // Por implementar
    abrirDetalheMigrado(this.props.history, e.row.data.chaveLancamento);
    return;
  }

  async cancelarDam() {
    const registro = this.state.damCancelamento;

    try {
      const formData = new FormData();
      const data = {
        prefeituraId: UserInfo.getPrefeitura(),
        damId: registro.id,
        lancamentoId: registro.lancamentoId,
        motivo: this.state.motivo,
      };

      formData.set("values", JSON.stringify(data));

      let config = { headers: { "Content-Type": "multipart/form-data" } };
      const response = await apiAxios.post(
        `dam/cancelar_dams/`,
        formData,
        config
      );

      if (response.status === 200) {
        notify("DAM cancelada com sucesso!", "success");
      }

      this.setState({ ...this.state, popupMotivoCancelarDam: false });
      console.log("grid instante", this._gridInstance);
      this._gridInstance.instance.refresh();
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="frmPesquisa"
            formData={this.state.filtro}
            colCount={6}
            labelLocation="top"
          >
            <SimpleItem
              dataField="exercicio"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="Exercício" />
            </SimpleItem>
            <SimpleItem
              dataField="dam"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="Cód. DAM" />
            </SimpleItem>
            <SimpleItem
              dataField="codContribuinte"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="Cód. Contribuinte" />
            </SimpleItem>
            <SimpleItem
              dataField="codImovel"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="Imóvel" />
            </SimpleItem>
            <SimpleItem
              dataField="codCpbs"
              colSpan={1}
              dataType={"number"}
              editorType={"dxNumberBox"}
            >
              <Label text="CPBS" />
            </SimpleItem>

            <SimpleItem dataField="cpfCnpj" colSpan={2}>
              <Label text="CPF/CNPJ" />
            </SimpleItem>

            <SimpleItem dataField="nomeContribuinte" colSpan={4}>
              <Label text="Nome Contribuinte" />
            </SimpleItem>

            <SimpleItem dataField="origem" colSpan={1}>
              <Label text="Origem" />
            </SimpleItem>

            <SimpleItem dataField="taxasSeqs" colSpan={1}>
              <Label text="Cód. Taxas" />
            </SimpleItem>


            <SimpleItem
              dataField="tipoData"
              editorType={"dxSelectBox"}
              editorOptions={this.tipoDataOpcoes}
            >
              <Label text="Tipo Data" />
            </SimpleItem>

            <SimpleItem
              dataField="dataInicial"
              dataType={"date"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
            >
              <Label text="Data Inicial" />
            </SimpleItem>

            <SimpleItem
              dataField="dataFinal"
              dataType={"date"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
            >
              <Label text="Data Final" />
            </SimpleItem>

            <SimpleItem
              colSpan={3}
              dataField="codAgenteRecebedor"
              editorType={"dxSelectBox"}
              editorOptions={this.agentesRecebedoresOpcoes}
            >
              <Label text="Inst. Financeira" />
            </SimpleItem>
            <SimpleItem
              dataField="tipoValor"
              editorType={"dxSelectBox"}
              editorOptions={this.tipoValorOptions}
            >
              <Label text="Tipo de Valor" />
            </SimpleItem>
            <SimpleItem
              dataField="valorInicial"
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtFrmCpbsNumerico"}
            >
              <Label text="Vr. Inicial (R$)" />
            </SimpleItem>

            <SimpleItem
              dataField="valorFinal"
              editorType={"dxNumberBox"}
              editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              cssClass={"txtFrmCpbsNumerico"}
            >
              <Label text="Vr. Final (R$)" />
            </SimpleItem>
            <SimpleItem
              dataField="situacaoDam"
              editorType={"dxSelectBox"}
              editorOptions={{ ...this.tipoSituacaoOptions, dataSource: this.state.listaFiltrosUI }}
              value
              colSpan={3}
            >
              <Label text="Situação do DAM" />
            </SimpleItem>
          </Form>
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button
                text="Atualizar DAM's"
                type="default"
                onClick={this.atualizarDams}
              />
            </div>
          </div>
        </form>
        <br />
        <PaginaToolbar
          titulo="Lista de DAM's"
          ocultarNovo={true}
          printData={() => this.state.filtro}
        >
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.damDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            focusedRowEnabled={true}
            allowColumnReordering={true}
          >
            <Column
              dataField={"id"}
              visible={false}
              showInColumnChooser={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                {
                  hint: "Cancelar",
                  icon: "remove",
                  onClick: (e) => {
                    this.popupsCancelarDam(e);
                  },
                },
                {
                  hint: "Detalhe",
                  icon: "more",
                  onClick: (e) => {
                    this.abrirDetalheLancamento(e);
                  },
                },
                {
                  hint: "Imprimir",
                  icon: "exportpdf",
                  onClick: (e) => {
                    const data = e.row.data;
                    imprimirDamFunction(
                      data.prefeituraId,
                      data.lancamentoId,
                      data.chaveLancamento
                    );
                  },
                },
              ]}
            />
            <Column
              dataField={"sequencial"}
              caption={"#"}
              alignment={"center"}
              width={95}
              sortIndex={0}
              sortOrder={"desc"}
            />
            <Column dataField={"exercicio"} caption={"Exercício"} />
            <Column dataField={"situacaoPagto"} caption={"Situação"} />
            <Column dataField={"tipo.codigoUI"} caption={"Tipo"} />

            <Column
              dataField={"dataDeEmissao"}
              caption={"Emissão"}
              dataType={"date"}
              visible={false}
            />
            <Column
              dataField={"dataDeVencimentoOriginal"}
              caption={"Venc. Orig."}
              dataType="date"
              visible={false}
            />
            <Column
              dataField={"dataDeVencimento"}
              caption={"Vencimento"}
              dataType="date"
            />

            <Column
              dataField={"valor"}
              dataType={"number"}
              caption={"Valor"}
              format={uiInfo.formatoNumerico.n2}
            />

            <Column
              dataField={"juros"}
              dataType={"number"}
              caption={"Juros"}
              format={uiInfo.formatoNumerico.n2}
              visible={false}
            />

            <Column
              dataField={"multa"}
              dataType={"number"}
              caption={"Multa"}
              format={uiInfo.formatoNumerico.n2}
              visible={false}
            />

            <Column
              dataField={"correcao"}
              dataType={"number"}
              caption={"Correção"}
              format={uiInfo.formatoNumerico.n2}
              visible={false}
            />

            <Column
              dataField={"valorTotal"}
              dataType={"number"}
              caption={"Vr. Atualizado"}
              format={uiInfo.formatoNumerico.n2}
            />

            <Column dataField={"receita.origem"} caption={"Origem"} />
            <Column dataField={"numeroParcelaStr"} caption={"Parcela"} />
            <Column dataField={"contribuinte.sequencial"} caption={"IMC"} />
            <Column dataField={"contribuinte.nome"} caption={"Responsável"} />
            <Column
              dataField={"contribuinte.documentoFormatado"}
              caption={"Doc. Responsável"}
            />
            <Column dataField={"lancamento.sequencial"} caption={"Cód. Lan."} />
            <Column
              dataField={"imovel.sequencial"}
              caption={"Imóvel"}
            />
            <Column
              dataField={"cpbs.inscricao"}
              caption={"CPBS"}
            />
            <Column dataField={"veiculo.placa"} caption={"Placa"} />

            <Column
              dataField={"valorPago"}
              caption={"Vr. Pago"}
              format={uiInfo.formatoNumerico.n2}
            />
            <Column
              dataField={"dataDePagamento"}
              caption={"Dt. Pagto."}
              dataType={"date"}
              visible={false}
            />
            <Column
              dataField={"dataDeDeposito"}
              caption={"Dt. Crédito"}
              dataType={"date"}
            />
            <Column
              dataField={"agenteRecebedor.descricao"}
              caption={"Inst. Financeira"}
              visible={false}
            />
            <Column
              dataField={"lancamento.criadoPor.login"}
              caption={"Usuário"}
              visible={false}
            />
            <Column
              dataField={"obs"}
              caption={"Observação"}
              visible={false}
            />
            <Column
              dataField={"imovel.enderecoSemCidade"}
              caption={"Endereço Imóvel"}
              visible={false}
            />
            <Column
              dataField={"dataDeEmissao"}
              caption={"Dt. Criação"}
              dataType="date"
              visible={false}
            />

            <Column dataField={"lancamento.historico"} caption={"Histórico"} visible={false} />

            <Column caption={"Taxa"} visible={false} calculateCellValue={(e) => {

              return e == null || e.taxa == null ? "" : e.taxa.sequencial.toString().padStart(2, '0') + " - " + e.taxa.descricao;
            }} />

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

            <Pager
              showInfo={true}
              showNavigationButtons={true}
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>

        <Popup
          visible={this.state.popupDamsNaoPagos}
          onHiding={() => this.setState({ popupDamsNaoPagos: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"60%"}
          height={500}
          title="Atualizar DAMs"
        >
          <Form formData={this.state} colCount={3} labelLocation="top">
            <SimpleItem
              dataField="novaData"
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%", useMaskBehavior: true }}
            >
              <Label text="Nova Data" />
            </SimpleItem>
            <SimpleItem
              dataField="encargos"
              editorType={"dxSelectBox"}
              editorOptions={this.encargoOptions}
            >
              <Label text="Encargos" />
            </SimpleItem>
            <SimpleItem
              dataField="somenteVencidos"
              editorType={"dxSelectBox"}
              editorOptions={this.somenteVencidosOptions}
            >
              <Label text="Somente Vencidos" />
            </SimpleItem>
          </Form>
          <div style={{ marginTop: "5px", height: "400px" }}>
            <DataGrid
              ref={(grid) => (this._gridAtualizarDams = grid)}
              dataSource={this.state.damsNaoPagos}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              focusedRowEnabled={true}
              allowColumnReordering={true}
              key={"id"}
              keyExpr={"id"}
              onSelectionChanged={(e) => this.onSelection(e)}
              defaultSelectedRowKeys={this.state.damsSelectionados}
              height={300}
            >
              <Selection
                mode="multiple"
                selectAllMode="allPages"
                showCheckBoxesMode="always"
              />

              <Column
                dataField={"id"}
                visible={false}
                showInColumnChooser={false}
              >
                <FormItem visible={false}></FormItem>
              </Column>
              <Column
                dataField={"sequencial"}
                caption={"#"}
                alignment={"center"}
                width={100}
                sortOrder={"desc"}
                sortIndex={0}
              />
              <Column
                dataField={"exercicio"}
                caption={"Exercício"}
                width={80}
              />
              <Column
                dataField={"situacaoPagto"}
                caption={"Situação"}
                width={110}
              />
              <Column
                dataField={"dataDeVencimento"}
                caption={"Vencimento"}
                dataType="date"
                width={100}
              />
              <Column dataField={"receita.origem"} caption={"Origem"} />
              <Column dataField={"numeroParcelaStr"} caption={"Parcela"} />
              <Column
                dataField={"valor"}
                dataType={"number"}
                caption={"Valor"}
                format={uiInfo.formatoNumerico.n2}
                width={130}
              />
            </DataGrid>
          </div>

          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupDamsNaoPagos: false }),
            }}
          />
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Atualizar",
              type: "success",
              width: 150,
              onClick: () => {
                this.executarAtualizacaoDams().then(() => {
                  this.setState({ popupDamsNaoPagos: false });
                  this._gridInstance.instance.refresh();
                });
              },
            }}
          />
        </Popup>

        <Popup
          visible={this.state.popupCancelarDamDIAT}
          onHiding={() => this.setState({ popupCancelarDamDIAT: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"40%"}
          height={200}
          title="Cancelar DAM"
        >
          <p>
            Cancelamento de DAM da dívida ativa só pode ser feito pela tela de
            acordos!
          </p>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupCancelarDamDIAT: false }),
            }}
          ></ToolbarItem>
        </Popup>

        <Popup
          visible={this.state.popupInfoParcelaDam}
          onHiding={() => this.setState({ popupInfoParcelaDam: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"40%"}
          height={200}
          title="Cancelar DAM"
        >
          <p>A DAM possui mais de uma parcela, todas serão canceladas!</p>

          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Entendi",
              type: "success",
              width: 150,
              onClick: (e) => {
                return this.setState({ popupMotivoCancelarDam: true });
              },
            }}
          />
        </Popup>

        <Popup
          visible={this.state.popupMotivoCancelarDam}
          onHiding={() => this.setState({ popupMotivoCancelarDam: false })}
          dragEnabled={false}
          closeOnOutsideClick={true}
          showCloseButton={true}
          showTitle={true}
          width={"50%"}
          height={255}
          title="Cancelar DAM"
        >
          <Form formData={this.state} colCount={1} labelLocation="top">
            <SimpleItem
              dataField={"motivo"}
              editorType={"dxTextArea"}
              editorOptions={{ height: "100px" }}
            >
              <Label text="Motivo do Cancelamento" />
            </SimpleItem>
          </Form>

          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Cancelar DAM",
              type: "success",
              width: 150,
              onClick: () => {
                this.cancelarDam();
              },
            }}
          />
        </Popup>
      </div>
    );
  }
}
